var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellSettingsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.584 0C6.64 0 2.626 4.348 2.626 9.704v8.212c0 .824-.473 1.966-1.056 2.548L.168 21.867c-.292.291-.194.527.218.527h22.395c.412 0 .51-.236.219-.527l-1.403-1.403c-.582-.582-1.056-1.724-1.056-2.548V9.704C20.541 4.348 16.529 0 11.584 0zM8.598 24.1c0 1.53 1.338 2.773 2.986 2.773 1.648 0 2.985-1.243 2.985-2.774 0-.117-.102-.212-.227-.212H8.825c-.125 0-.227.095-.227.212z",
    fill: "#CACACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellSettingsIcon);
export default __webpack_public_path__ + "static/media/bell-settings-icon.fe051c64027192f52e0a6381f93b99ce.svg";
export { ForwardRef as ReactComponent };